import type {Router} from 'src/types/router';
import type {
  // @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'EventCalendarItem'. Did you mean to use 'import EventCalendarItem from "src/api-parsers/events"' instead?
  EventCalendarItem,
  // @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'EventCalendarRecipient'. Did you mean to use 'import EventCalendarRecipient from "src/api-parsers/events"' instead?
  EventCalendarRecipient,
  // @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'EventCalendarAudiencePreview'. Did you mean to use 'import EventCalendarAudiencePreview from "src/api-parsers/events"' instead?
  EventCalendarAudiencePreview,
} from 'src/api-parsers/events';

import * as React from 'react';
import {useSelector} from 'react-redux';

import {selectEntityMappingsByName} from 'src/selectors/ats-entities';
import {fluxify} from 'src/flux/component';
import Loading from 'src/components/lib/loading';
import Table, {Cells, Cell} from 'src/components/lib/table';
import {TitleBarModal} from 'src/components/modals/base-modal';

import {getEventCalendarAudiencePreviewPage} from 'src/actions/schedule';

import css from './event-audience-modal.css';


const tableHeader = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'deliveryAddress',
    label: 'Delivery Address',
  },
];

function EventAudienceModal(props: {
  store: any;
  router: Router;
  calendarEvent: EventCalendarItem;
  audiencePreview: EventCalendarAudiencePreview;
  removeModal: () => void;
  fetchAudiencePreview: (dateString: string, eventId: string) => void;
  loading: Promise<any> | null | undefined;
}) {
  const {
    router,
    loading,
    calendarEvent,
    audiencePreview,
    fetchAudiencePreview,
    removeModal,
  } = props;

  return (
    <TitleBarModal
      className={css.container}
      title={`Recipients of ${calendarEvent.eventTitle}`}
      type={'EVENT_AUDIENCE'}
      handleAbort={removeModal}
      handleConfirm={removeModal}
      confirmText={!loading ? 'Okay' : ''}
    >
      <Audience
        router={router}
        loading={loading}
        calendarEvent={calendarEvent}
        audiencePreview={audiencePreview}
        fetchAudiencePreview={fetchAudiencePreview}
        removeModal={removeModal}
      />
    </TitleBarModal>
  );
}

// @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type. | TS7031 - Binding element 'dateString' implicitly has an 'any' type. | TS7031 - Binding element 'eventId' implicitly has an 'any' type.
const mapper = ({store, calendarEvent: {dateString, eventId}}) => {
  // @ts-expect-error - TS18046 - 'getEventCalendarAudiencePreviewPage' is of type 'unknown'.
  const key = getEventCalendarAudiencePreviewPage.KEY(dateString, eventId);
  return {
    loading: store.request.inProgress(key) || null,
    audiencePreview: store.schedule.getAudiencePreview(dateString, eventId),
  };
};

// @ts-expect-error - TS2345 - Argument of type '(props: { store: any; router: BaseHistory; calendarEvent: EventCalendarItem; audiencePreview: EventCalendarAudiencePreview; removeModal: () => void; fetchAudiencePreview: (dateString: string, eventId: string) => void; loading: Promise<...> | ... 1 more ... | undefined; }) => Element' is not assignable to parameter of type 'AbstractComponent<{ store: any; calendarEvent: { dateString: any; eventId: any; }; }, any>'.
export default fluxify(mapper)(EventAudienceModal) as React.ComponentType<any>;

const Recipient = ({
  data: {recipientId, name, deliveryAddress, entityUrl},
  extras: {router, removeModal},
}: {
  data: EventCalendarRecipient;
  extras: {
    router: Router;
    removeModal: () => unknown;
  };
}) => (
  <Cells>
    <Cell>
      <span
        className={css.name}
        onClick={() => {
          if (entityUrl) {
            removeModal();
            router.push(`/people/${entityUrl}/${recipientId}`);
          }
        }}
      >
        {name}
      </span>
    </Cell>
    <Cell>{deliveryAddress}</Cell>
  </Cells>
);

function Audience(props: {
  audiencePreview: EventCalendarAudiencePreview | null | undefined;
  calendarEvent: EventCalendarItem;
  loading: Promise<any> | null | undefined;
  fetchAudiencePreview: (dateString: string, eventId: string) => void;
  router: Router;
  removeModal: () => unknown;
}) {
  let {loading} = props;
  const {
    audiencePreview,
    calendarEvent,
    fetchAudiencePreview,
    router,
    removeModal,
  } = props;

  // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
  const scrollerRef = React.useRef();
  const entitySchemas = useSelector(selectEntityMappingsByName);

  const recipients = React.useMemo(
    () =>
      audiencePreview &&
      // @ts-expect-error - TS7006 - Parameter 'recipient' implicitly has an 'any' type.
      audiencePreview.recipients.map((recipient) => ({
        ...recipient,
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<EntityType, AtsEntity>>'.
        entityUrl: entitySchemas[recipient.recipientEntityType]?.url,
      })),
    [entitySchemas, audiencePreview],
  );

  React.useEffect(() => {
    const {dateString, eventId} = calendarEvent;

    if (!audiencePreview) {
      fetchAudiencePreview(dateString, eventId);
    }
  }, []);

  const handleScroll = () => {
    const {dateString, eventId} = calendarEvent;
    const isDone = audiencePreview && audiencePreview.isDone;

    if (!scrollerRef.current) {
      return;
    }

    const {
      // @ts-expect-error - TS2339 - Property 'scrollTop' does not exist on type '{}'. | TS2339 - Property 'scrollHeight' does not exist on type '{}'. | TS2339 - Property 'clientHeight' does not exist on type '{}'.
      current: {scrollTop, scrollHeight, clientHeight},
    } = scrollerRef;

    if (!fetchAudiencePreview || isDone) {
      return;
    }

    if (scrollTop + clientHeight >= scrollHeight) {
      return fetchAudiencePreview(dateString, eventId);
    }
  };

  if (!audiencePreview) {
    // @ts-expect-error - TS2322 - Type 'boolean' is not assignable to type 'Promise<any>'.
    loading = true;
  }

  return (
    // @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type 'Ref<HTMLDivElement> | undefined'.
    <div className={css.scrollWrap} onScroll={handleScroll} ref={scrollerRef}>
      {recipients && (
        <Table
          className={css.table}
          header={tableHeader}
          // @ts-expect-error - TS2769 - No overload matches this call.
          Row={Recipient}
          entries={recipients}
          extras={{router, removeModal}}
          idName="deliveryAddress"
          sortable={false}
        />
      )}
      {loading && <Loading className={css.loader} animationDelay={0} />}
    </div>
  );
}
